import { clearLocalStorage } from '../component/helpers/Common';
import EventEmitter, {
  SESSION_TIME_OUT,
} from '../component/helpers/EventEmitter';
import IdentityServerConfig from '../configs/IdentityServerConfig';
import { UserManager } from 'oidc-client';
import Fingerprint2 from 'fingerprintjs2';

class AuthenticationProvider {
  _usrMgr;
  constructor(config) {
    this._usrMgr = new UserManager(IdentityServerConfig);
    let me = this;

    Fingerprint2.get(components => {
      var values = components.map(function(component) {
        return component.value;
      });
      var fp = Fingerprint2.x64hash128(values.join(''), 31);

      me._usrMgr.settings.extraQueryParams = {
        ...{ clientType: 'WEBCLIENT', fp: fp },
      };
    });

    this._usrMgr.events.addSilentRenewError(function(e) {
      me._usrMgr.getUser().then(user => {
        if (!user || user.expired) {
          clearLocalStorage();
          EventEmitter.dispatch(SESSION_TIME_OUT);
        }
      });
    });

    //this event is not valid - different from oidc-client homepage
    // this._usrMgr.events.accessTokenExpired(function(e) {
    //     this._usrMgr.getUser().then(user => {
    //         if(!user || user.expired) {
    //             alert('Your login session is expired! Please login again.');
    //             window.location.href = '/';
    //         }
    //     });
    // })

    this._usrMgr.events.addUserSessionChanged(user => {
      console.log('fire');
    });

    // if(window.location.hash) {
    //     this._usrMgr.signinRedirectCallback().then(user => {
    //         window.location = "/desktop";
    //     });
    // }

    window.addEventListener('resume', function(event) {
      me.proccessComeBack(event);
    });

    window.addEventListener('focus', function(event) {
      me.proccessComeBack(event);
    });

    window.addEventListener(
      'pageshow',
      function(event) {
        me.proccessComeBack(event);
      },
      false,
    );
  }

  proccessComeBack(event) {
    let me = this;
    this._usrMgr.getUser().then(user => {
      if (user && user.expired) {
        //EventEmitter.dispatch(SESSION_TIME_OUT);

        //me.clearStaleState();
        me.removeUser();
        me.signin();
        //EventEmitter.dispatch(SESSION_TIME_OUT);
      }
    });
  }

  clearStaleState() {
    this._usrMgr.clearStaleState();
  }

  removeUser() {
    return this._usrMgr.removeUser();
  }

  getUser() {
    return new Promise((resolve, reject) => {
      try {
        this._usrMgr.getUser().then(user => {
          if (user && user.expired) {
            resolve(null);
            return;
          }

          resolve(user);
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  signin(options) {
    // var extraQueryParams = {
    //   type: window.opener ? 'popup' : 'redirect',
    // };
    this._usrMgr.signinRedirect({
      ...options,
      extraQueryParams: {
        ...this._usrMgr.settings.extraQueryParams,
        type: window.opener ? 'popup' : 'redirect',
      },
    });
  }

  signinCallback() {
    return this._usrMgr.signinRedirectCallback();
  }

  signout() {
    return this._usrMgr.signoutRedirect();
  }

  signinSilentCallback() {
    return this._usrMgr.signinSilentCallback();
  }

  signinSilent() {
    return this._usrMgr.signinSilent();
  }

  signinPopup() {
    return this._usrMgr.signinPopup();
  }
}

const authProvider = new AuthenticationProvider(IdentityServerConfig);

export default authProvider;
